/**
 * The one place that knows how to link to a photo in Baza de date.
 *
 * `/app/database?photo=<id>` opens that photo's detail modal on arrival,
 * so a photo reached from a polygon (its map marker, or the polygon's
 * photo list) lands on the full record rather than dumping the user at
 * page 1 of an unfiltered table to hunt for it.
 *
 * The id goes in the query string rather than the path because the page
 * is a list first: the deep link is a starting position, and clearing it
 * leaves the user on a working table instead of a dead route.
 */
export const PHOTO_QUERY_PARAM = 'photo';

export function photoHref(photoId: string): string {
  return `/app/database?${PHOTO_QUERY_PARAM}=${encodeURIComponent(photoId)}`;
}
